import { z } from 'zod';
import { DateTimeSchema, ObjectIdSchema, ObjectIdString } from '../common.js';

export const IAccount = z.object({
  _id: ObjectIdSchema,
  name: z.string(),
  status: z.string(),
  emailDomains: z.string().array().default([]),
  isInternal: z.boolean().default(false),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IAccount = z.infer<typeof IAccount>;

export const AccountDTO = z.object({
  ...IAccount.shape,
  _id: ObjectIdString,
  createdAt: DateTimeSchema.nullish(),
  updatedAt: DateTimeSchema.nullish(),
});
export type AccountDTO = z.infer<typeof AccountDTO>;

export const AccountCreateSchema = z.object({
  name: z.string(),
  status: z.string().default('active'),
  emailDomains: z.array(z.string()).default([]),
  isInternal: z.boolean().default(false),
});

export const AccountUpdateSchema = z.object({
  name: z.string().optional(),
  status: z.string().optional(),
  emailDomains: z.array(z.string()).optional(),
  isInternal: z.boolean().optional(),
});
